import { camelizeKeys } from 'humps';
import { getAsJson, post, validateScheme } from '@namespace/helpers';
import { apiRoutes } from './apiRoutes';
import {
  getAllCardsResponseDataShema,
  putCVVToCacheResponseDataShema,
  saveBankCardResponseShema
} from './shemas';
import {
  DeleteBankCardParams,
  DeleteBankCardResponseData,
  GetAllCardsParams,
  GetAllCardsResponseData,
  PutCVVToCacheParams,
  PutCVVToCacheResponseData,
  SaveBankCardParams,
  SaveBankCardResponse,
  SaveBankCardResponseData
} from './types';

export const getAllCards = ({ userId }: GetAllCardsParams) =>
  getAsJson<GetAllCardsResponseData>(apiRoutes.pans(userId)).then((data) => {
    validateScheme(getAllCardsResponseDataShema, data, { name: 'getAllCards' });

    return camelizeKeys<GetAllCardsResponseData>(data);
  });

export const deleteBankCard = (body: DeleteBankCardParams) =>
  post<DeleteBankCardResponseData>({
    url: apiRoutes.deletePan(),
    body,
    mode: 'cors'
  }).then((data) => camelizeKeys<DeleteBankCardResponseData>(data));

export const saveBankCard = (body: SaveBankCardParams) =>
  post<SaveBankCardResponseData>({
    url: apiRoutes.savePan(),
    body,
    mode: 'cors'
  }).then(({ response }) => {
    validateScheme(saveBankCardResponseShema, response, {
      name: 'saveBankCard'
    });

    return camelizeKeys<SaveBankCardResponse>(response);
  });

export const putCVVToCache = ({
  cardHash,
  userId,
  accountingId,
  cvv,
  ssid
}: PutCVVToCacheParams) =>
  post<PutCVVToCacheResponseData>({
    url: apiRoutes.putCvv(),
    body: {
      user_id: String(userId),
      accounting_id: accountingId,
      ssid,
      card_hash: cardHash,
      cvv
    },
    timeout: 60000
  }).then((data) => {
    validateScheme(putCVVToCacheResponseDataShema, data, {
      name: 'putCVVToCache'
    });

    return camelizeKeys<PutCVVToCacheResponseData>(data);
  });
